import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";

export default class InvoicePayment extends BaseModel {
  uuid = null;
  invoice_no = null;
  amount = null;
  initial_amount = null;
  converted_amount = null;

  rules = {
    invoice_no: 'required',
    amount: 'required',
  };

  attributeLabels = {
    invoice_no: i18n.t('Invoice N'),
    amount: i18n.t('Amount'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this)
    this.initial_amount = this.amount
  }
}

defineTranslatableProperties(InvoicePayment);
